import React, { FC } from 'react';
import { ProjectFormProps } from '../ProjectForm/ProjectFormProps';
import ProjectDetailsFields from '../ProjectDetailsFields';
import Divider from '../../Divider';
import ProjectDatesFields from '../ProjectDatesFields';
import useTranslation from '../../../hooks/useTranslation';
import Text from '@ingka/text';
import ProjectConfidentialButton from '../ProjectConfidentialButton';
import CustomMultilineInput from '../../../common/CustomMultilineInput';
import ProjectPeopleSection from '../../ProjectPeopleSection';
import CustomSelect from '../../../common/CustomSelect';
import { getOptionsFromTranslation } from '../../../utils/utils';
import PartOfCrpForm from '../PartOfCrpForm';

const ProjectTabCloseProjectForm: FC<ProjectFormProps> = ({
  projectList,
  isep,
}) => {
  const t = useTranslation();
  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectDetails')}
      </Text>
      <ProjectDetailsFields
        projectList={projectList}
        unifier={isep}
        type={'Close'}
      />

      <CustomSelect
        optionsArray={getOptionsFromTranslation(
          t,
          'terminationOfFranchiseeAgreement',
        )}
        label={t('labels.terminationOfFranchiseeAgreement')}
        name={'terminationOfFranchiseeAgreement'}
      />
      <CustomMultilineInput
        name={'projectBackgroundAndScope'}
        label={'Project background and scope'}
        dataTestID={'project-background-and-scope'}
      />
      <CustomMultilineInput
        name={'reasonForClosing'}
        label={'Reason for closing'}
        dataTestID={'reason-for-closing'}
      />
      <Divider />
      <ProjectConfidentialButton />
      <Divider />
      <PartOfCrpForm />
      <Divider />
      <ProjectDatesFields
        openingDate
        closeLabel
        initialDates
        establishmentTypeClose
        isep={isep}
        projectClosingDate
      />
      <Divider />
      <ProjectPeopleSection />
    </>
  );
};

export default ProjectTabCloseProjectForm;
